export default "__VITE_ASSET__0e422676__"